import styles from './EntityCell.module.scss';

import React from 'react';

export const EmptyCell: React.FC = () => {
  return <div className={styles.main}></div>;
};
